<template>
    <c-dialog ref="dialog" title="查看备注" width="900" height="600" :button="false">
        <c-table :data="list" border :paging="false">
            <template #empty>
                <c-empty message="暂无备注信息"></c-empty>
            </template>
            <!-- <c-table-column type="selector" width="40"></c-table-column> -->
            <c-table-column label="备注ID" name="id" width="80"></c-table-column>
            <c-table-column label="备注来源" name="source_name" width="100"></c-table-column>
            <c-table-column label="背贴码" name="produce_unique_code" width="160"></c-table-column>
            <c-table-column label="备注内容" name="remark" min-width="220"></c-table-column>
            <c-table-column label="操作人" name="create_user_realname" width="100"></c-table-column>
            <c-table-column label="备注时间" name="create_date" width="150"></c-table-column>
        </c-table>
    </c-dialog>
</template>

<script>
export default {
    name: 'codeRemark',

    data() {
        return {
            list: []
        }
    },

    methods: {
        /**
         * 打开备注弹窗（聚合各来源单据创建时填写的备注：线下采购/质检维修销售调拨/分润调拨/线下销售）
         * @param data 背贴码行数据（id=条码ID，produce_unique_code=背贴码）
         */
        open(data) {
            this.list = [];
            this.$refs.dialog.open();
            this.request({
                url: '/productCode/remark/listByCodeId',
                data: {
                    produce_unique_code_id: data.id,
                    produce_unique_code: data.produce_unique_code
                },
                loading: true,
                success: data => {
                    this.list = data || [];
                }
            });
        }
    }
}
</script>
